export class PublisherModel {
  name: string;
  nbrPublished: number;

  constructor(name: string, nbrPublished: number) {
    this.name = name;
    this.nbrPublished = nbrPublished;
  }
}
